import { makeStub } from "./_base";
export const Batch = makeStub("Batch");
